export default function ImmigrantResources() {
  const resources = [
    {
      number: 'I',
      title: 'Your Rights as an Immigrant',
      description: 'Regardless of your immigration status, you have the right to seek compensation for injuries caused by someone else\'s negligence. Indiana law protects all injured persons, including undocumented immigrants.',
      points: [
        'Right to medical treatment for work injuries',
        'Right to file personal injury claims',
        'Protection from employer retaliation',
        'Confidentiality of your immigration status'
      ]
    },
    {
      number: 'II',
      title: 'What to Do After an Accident',
      description: 'Taking the right steps immediately after an accident can strengthen your case. Here\'s what you should do to protect your rights and maximize your compensation.',
      points: [
        'Seek immediate medical attention and keep all records',
        'Document the accident scene with photos if possible',
        'Get contact information from witnesses',
        'Report the incident to your employer or police',
        'Do NOT sign any documents without legal advice',
        'Contact our office for a free consultation'
      ]
    },
    {
      number: 'III',
      title: 'Common Questions',
      description: 'We understand you may have concerns about seeking legal help. Here are answers to questions we frequently hear from immigrant clients in Indiana.',
      points: [
        'Will filing a claim affect my immigration status? No, personal injury claims are civil matters separate from immigration.',
        'Do I need a Social Security Number? No, you can file a claim with an ITIN or other identification.',
        'What if I don\'t speak English? We provide interpreters and multilingual attorneys.',
        'How much does it cost? Nothing upfront - we only get paid if you win.'
      ]
    },
    {
      number: 'IV',
      title: 'Community Resources',
      description: 'We partner with local organizations to support immigrant communities in Indiana. These resources can help you with various needs beyond legal representation.',
      points: [
        'Indiana Immigrant Rights Coalition',
        'Catholic Charities Immigration Services',
        'La Plaza Community Center',
        'Asian American Alliance',
        'Burmese American Community Institute',
        'Local ESL and citizenship classes'
      ]
    }
  ];

  return (
    <section id="resources" className="py-16 bg-lavender-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="mb-12 max-w-4xl">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">Resources</p>
          <h2 className="text-6xl md:text-7xl font-light text-gray-900 leading-tight mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
            Immigrant<br />
            <span className="italic font-normal">Resources</span>
          </h2>
          <p className="text-base text-gray-600 leading-relaxed border-l-2 border-gray-900 pl-6" style={{ fontFamily: "'Crimson Pro', serif" }}>
            Knowledge is power. Understanding your rights and available resources is the first step toward getting the justice and compensation you deserve after an injury in Indiana.
          </p>
        </div>

        {/* Resources grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {resources.map((resource, index) => (
            <article key={index} className="bg-lavender-50 border border-gray-200 p-10">
              <div className="flex items-start gap-6 mb-6">
                <span className="text-5xl font-light text-gray-300" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {resource.number}
                </span>
                <div className="flex-1">
                  <h3 className="text-2xl font-light text-gray-900 mb-3 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {resource.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6" style={{ fontFamily: "'Crimson Pro', serif" }}>
                    {resource.description}
                  </p>
                </div>
              </div>
              
              <ul className="space-y-3 pl-20">
                {resource.points.map((point, idx) => (
                  <li key={idx} className="text-sm text-gray-700 leading-relaxed border-l border-gray-300 pl-4" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Language support callout */}
        <div className="mt-12 border-t-2 border-b-2 border-gray-900 py-10">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-4xl font-light text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              We Speak Your Language
            </h3>
            <p className="text-base text-gray-600 mb-8 leading-relaxed" style={{ fontFamily: "'Crimson Pro', serif" }}>
              Our multilingual team is ready to help you in English, Spanish, Korean, and Chinese. Don't let language barriers prevent you from getting the legal help you need and deserve.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              {['English', 'Español', '한국어', '中文'].map((lang, idx) => (
                <span key={idx} className="text-xs tracking-wider uppercase border border-gray-400 text-gray-700 px-4 py-2">
                  {lang}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
